export default __webpack_public_path__ + "static/media/ic_language.d713fbd9.svg";